import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { SqlSearchService } from '../../sql-search/sql-search.service';
import { Observable, of, map, catchError, isObservable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormValidationService {

  constructor(private sqlSearchService: SqlSearchService) { }

  static required(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === 0) return null;

      return value ? null : { required: true };
    };
  }

  // minLength
  static min(minlength, fieldtype): ValidatorFn {
    fieldtype = fieldtype.trim().toLowerCase();
    return (control: AbstractControl): ValidationErrors | null => {
      let value = control.value;
      if (value === null || value === undefined) {
        return null;
      }

      if (fieldtype === 'charactervarying' || fieldtype === 'nvarchar' || fieldtype === 'text' || fieldtype === 'varchar') {
        // return value.replace(/\s+/g, '').trim().length >= minlength ? null : { min: { minlength: minlength, actualLength: value } };
        return value.length >= minlength ? null : { minLength: { minLength: minlength, actualLength: value } };
      }

      else if (fieldtype === 'datetime2') {
        const inputDate = new Date(value);
        if (isNaN(inputDate.getTime())) {
          return { invalidDate: true };
        }

        return (inputDate >= minlength) ? null : { minDate: { requiredDate: minlength.toISOString().split('T')[0], actualDate: value } };

      }

      else {
        value = Number(value);
        minlength = Number(minlength);
        return value >= minlength ? null : { min: { minLength: minlength, actuallength: value } };
      } //for numbers

    };
  }
static requiredArray() {
  return (control: AbstractControl) => {
    const value = control.value;
    return Array.isArray(value) && value.length === 0
      ? { required: true }
      : null;
  };
}

  // maxLength
  static max(maxlength, fieldtype): ValidatorFn {
    // fieldtype = fieldtype?.toString().trim().toLowerCase();
    fieldtype = fieldtype?.toString().replace(/\s+/g, '').toLowerCase();
    // console.log('fieldtype:', fieldtype);
    return (control: AbstractControl): ValidationErrors | null => {
      let value = control.value;
      // console.log(typeof value, typeof maxlength)
      // console.log('value:', value.replace(/\s+/g, '').trim().length);
      if (value === null || value === undefined) {
        return null; // check if not null or undefined
      }

      if (fieldtype === 'charactervarying' || fieldtype === 'nvarchar' || fieldtype === 'text' || fieldtype === 'varchar') {
        // debugger
        // return value.replace(/\s+/g, '').trim().length <= maxlength ? null : { max: { maxlength: maxlength, actualLength: value.length } };
        return value.length <= maxlength ? null : { maxLength: { maxLength: maxlength, actualLength: value.length } };
      }

      else if (fieldtype === 'datetime2') {
        const inputDate = new Date(value);
        if (isNaN(inputDate.getTime())) {
          return { invalidDate: true };
        }

        return (inputDate <= maxlength) ? null : { maxDate: { requiredDate: maxlength.toISOString().split('T')[0], actualDate: value } };

      }

      else {
        value = Number(value);
        maxlength = Number(maxlength);
        return value <= maxlength ? null : { max: { maxLength: maxlength, actuallength: value } }; //for numbers
      }

    };
  }

  //email validation
  static email(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === null || value === undefined) {
        return null; // check if not null or undefined
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      // /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/
      return value && emailRegex.test(value) ? null : { pattern: true };
    };
  }

  //text pattern validation

  //english pattern
  static enPattern(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const patternRegex = /^[a-zA-Z\s]+$/;
      // ^[a-zA-Z\s]+$/
      return value && patternRegex.test(value) ? null : { pattern: true };
    }
  }

  //arabic pattern
  static arPattern(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const patternRegex = /^[\u0621-\u064A\s]+$/;
      // }^[\u0600-\u06FF\s]+$
      return value && patternRegex.test(value) ? null : { pattern: true };
    }
  }

  //mixed pattern the field accept arabic or english
  static pattern(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const patternRegex = /^[\p{L}\s]+$/u;
      return value && patternRegex.test(value) ? null : { pattern: true };

    }
  }
  //end text pattern validation

  //Password validation
  //password pattern
  static passwordPattern(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
      return value && passwordRegex.test(value) ? null : { pattern: true };
    };
  }
  // confirm password

  static passwordMismatch(controlname: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.parent || !control.parent.get(controlname)) {
        return null; // check if field is exist
      }
      const value = control.value;
      const confirmPassword = control.parent.get(controlname)?.value; // استخدام parent بدلاً من root
      return value === confirmPassword ? null : { passwordMismatch: true };
    };
  }
  //end password validation

  //phone validation
  static phone(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      // console.log('Phone number value:', value.replace(/\s+/g, '').trim());
      if (!value) return null;
      const phoneRegex = /^\+[1-9]{1}[0-9]{1,3}(?:\s?[0-9]){4,14}$/;
      // /^\+\d{1,3}[\s-]?\d{4,}$/
      // /^\+([1-9]{1}[0-9]{0,2})\s?([0-9]{6,14})$/;
      // /^\+[1-9]{1}[0-9]{1,3}(?:\s?[0-9]){4,14}$/;
      // /^\+[1-9]{1}[0-9]{1,3}[0-9]{4,14}$/; //without spaces
      return value && phoneRegex.test(value) ? null : { pattern: true };
    }
  }

  //number validation
  static number(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const regexPattern = /^[0-9]+$/;
      return value && regexPattern.test(value) ? null : { pattern: true };
    }
  }

  static precision(precisionlength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === null || value === undefined) {
        return null; // check if not null or undefined
      }
      const decimalValue = value.toString().split('.')[1]; //value of decimal part
      if (decimalValue === null || decimalValue === undefined) {
        return null; // check if not null or undefined
      }

      return decimalValue.length <= precisionlength ? null : { precision: { requiredPrecision: precisionlength, actualPrecision: decimalValue.length } };

    };
  }

  stopDuplicate(fieldName: string, tableName: string, pageParameter: string): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const value = control.value;
      if (value === null || value === undefined || value === '') {
        return of(null);
      }

      // Guard: Check required parameters
      if (!tableName || !fieldName) {
        return of(null);
      }

      try {
        const check$ = this.sqlSearchService.checkIfFieldValueIsDuplicated(tableName, fieldName, value, pageParameter);

        // Guard: Ensure the service method returns an Observable
        if (!check$ || !isObservable(check$)) {
          return of(null);
        }

        return check$.pipe(
          map(isDuplicate => (isDuplicate?.result ? { duplicate: true } : null)),
          catchError((err) => {
            return of(null);
          })
        );
      } catch (err) {
        return of(null);
      }
    };
  }
}

